import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function MobileBottomNav() {
  const loc = useLocation();
  const { count, setOpen } = useCart();
  const openMenu = () => window.dispatchEvent(new Event("lara:open-menu"));
  if (loc.pathname.startsWith("/admin")) return null;

  const Item = ({ to, icon: Icon, label, testid, onClick }) => {
    const act = to && loc.pathname === to;
    const cls = act
      ? "flex flex-col items-center gap-0.5 text-[#C9708B] font-semibold text-[11px]"
      : "flex flex-col items-center gap-0.5 text-[#8C7A80] hover:text-[#C9708B] text-[11px] transition-colors";
    const content = <><Icon className="w-5 h-5" />{label}</>;
    return onClick ? (
      <button onClick={onClick} className={cls} data-testid={testid}>{content}</button>
    ) : (
      <Link to={to} className={cls} data-testid={testid}>{content}</Link>
    );
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-[#F9E1E8] z-40 px-4 py-2 flex justify-around items-center shadow-[0_-4px_12px_rgba(74,59,64,0.05)]" data-testid="mobile-bottom-nav">
      <Item to="/" icon={Home} label="Início" testid="mobile-nav-home" />
      <Item onClick={openMenu} icon={LayoutGrid} label="Categorias" testid="mobile-nav-categories" />
      <div className="relative">
        <Item onClick={() => setOpen(true)} icon={ShoppingBag} label="Carrinho" testid="mobile-nav-cart" />
        {count > 0 && <span className="absolute -top-1 right-0 bg-[#C9708B] text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center">{count}</span>}
      </div>
      <Item to="/minha-conta" icon={User} label="Conta" testid="mobile-nav-account" />
    </div>
  );
}
